// extracted by mini-css-extract-plugin
module.exports = {"routerContainer":"styles_routerContainer__23czB","particlesWrapper":"styles_particlesWrapper__3S-PQ","pageContainer":"styles_pageContainer__37qMJ"};